module.exports = __webpack_public_path__ + "static/media/icon-clip.f96781f6.svg";